
export enum RegisterTypeEnum {
  Main,
  Consumption,
  Battery,
  ProductionLineSide,
  ProductionBreakerSide
}

interface RegisterType {
  id: RegisterTypeEnum;
  label: string;
  grid: boolean;
  production: boolean;
  battery: boolean;
  displayClass: string;
}


const RegisterTypes = [
  {id: RegisterTypeEnum.Main, label: 'Main', grid: true, production: false, battery: false, displayClass: "badge bg-primary me-1"},
  {id: RegisterTypeEnum.Consumption, label: 'Consumption', grid: false, production: false, battery: false, displayClass: "badge bg-secondary me-1"},
  {id: RegisterTypeEnum.Battery, label: 'Battery', grid: false, production: false, battery: true, displayClass: "badge bg-success me-1"},
  {id: RegisterTypeEnum.ProductionLineSide, label: 'Production Line Side', grid: true, production: true, battery: false, displayClass: "badge bg-success me-1"},
  {id: RegisterTypeEnum.ProductionBreakerSide, label: 'Production Breaker Side', grid: false, production: true, battery: false, displayClass: "badge bg-success me-1"},
]

const registerTypeMap: Map<RegisterTypeEnum, RegisterType> = new Map();
registerTypeMap.forEach(registerType => registerTypeMap.set(registerType.id, registerType));

export interface Register {
  label: string;
  clamp_definition: string;
  grid: boolean;
  production: boolean;
  battery: boolean;
  multiplier: number;
  phase_shift: number;
  inverted: boolean;
  categories: string[];
}

export interface HubInstallation {
  location: string;
  ts_claimed: number | null;
  sample_period_ms: number;
  load_control_settings: any | null;
  panel_type: string;
  samples_per_post: number;
  label: string;
  state: string;
  ts_state_changed: number | null;
  registers: Register[];
}

export interface Hub {
  id: string;
  model_number: string;
  hub_connectivity: any;
  software: string | null;
  hardware: string;
  installation: HubInstallation;
  uuid: string;
  ts_created: number;
  ts_modified: number;
}

export function getRegisterTypes() {
  return RegisterTypes;
}

export function getRegisterFlags(registerTypeId: any){

  const result = {
    grid: false,
    production: false,
    battery: false
  }

  let idToFind = 0;

  if(typeof registerTypeId === 'string'){
    idToFind = parseInt(registerTypeId);
  } else {
    idToFind = registerTypeId;
  }

  const c = RegisterTypes.find(registerType =>
    registerType.id === idToFind);

  if(!c){
    return result;
  }

  result.grid = c.grid;
  result.production = c.production;
  result.battery = c.battery;

  return result;
}


export function getRegisterTypeLabel(register:Register){

  const c = RegisterTypes.find(registerType =>
    registerType.grid === register.grid &&
    registerType.production === register.production &&
    registerType.battery === register.battery);

  return c?.label;

}

export function getRegisterTypeDisplayClass(register:Register){

  const c = RegisterTypes.find(registerType =>
    registerType.grid === register.grid &&
    registerType.production === register.production && registerType.battery === register.battery
  )
  return c?.displayClass;
}

export function getRegisterTypeId(register:Register) :number{

  const c = RegisterTypes.find(registerType =>
    registerType.grid === register.grid &&
    registerType.production === register.production &&
    registerType.battery === register.battery);

  if(!c){
    return 0;
  }
  return c.id;

}

